import ListWrapper from "../utils/ListWrapper" ;
import DFile from "../classes/DFile" ;
import DBObject from "../utils/DBObject" ;
import CloneContext from "../utils/CloneContext" ;
import CollectionUtils from "../utils/CollectionUtils" ;


  export default  class  LeadImportFile extends  DBObject {  private static readonly _ERRORS: number = 0 ;
  private static readonly _FAILCOUNT: number = 1 ;
  private static readonly _FILE: number = 2 ;
  private static readonly _SUCCESS: number = 3 ;
  private static readonly _SUCCESSCOUNT: number = 4 ;
  public id: number = 0 ;
  public otherMaster: DBObject ;
  private _file: DFile = null ;
  private _success: boolean = false ;
  private _errors: Array<string> = ListWrapper.primitive(this,'errors',LeadImportFile._ERRORS) ;
  private _successCount: number = 0 ;
  private _failCount: number = 0 ;
 public constructor ( d3eParams ? : Partial<{errors: Array<string>, failCount: number, file: DFile, success: boolean, successCount: number}> ) {
 super();

this.setErrors(d3eParams?.errors ?? ListWrapper.primitive(this,'errors',LeadImportFile._ERRORS));

this.setFailCount(d3eParams?.failCount ?? 0);

this.setFile(d3eParams?.file ?? null);

this.setSuccess(d3eParams?.success ?? false);

this.setSuccessCount(d3eParams?.successCount ?? 0);
 }
  public get d3eType (  ) : string {
 return 'LeadImportFile' ; 
 }
  public clear (  ) : void {
 this.d3eChanges.clear();
 }
  public get isTransientModel (  ) : boolean {
 return ; 
 }
  public get file (  ) : DFile {
 return this._file ; 
 }
  public setFile ( val : DFile ) : void {
 let isValChanged :boolean=this._file !== val;

if ( !isValChanged ) {
 return ; 
 }

this.updateD3EChanges(LeadImportFile._FILE,this._file);

this._file=val;

this.fire('file',this);
 }
  public get success (  ) : boolean {
 return this._success ; 
 }
  public setSuccess ( val : boolean ) : void {
 let isValChanged :boolean=this._success !== val;

if ( !isValChanged ) {
 return ; 
 }

this.updateD3EChanges(LeadImportFile._SUCCESS,this._success);

this._success=val;

this.fire('success',this);
 }
  public get errors (  ) : Array<string> {
 return this._errors ; 
 }
  public setErrors ( val : Array<string> ) : void {
 let isValChanged :boolean=CollectionUtils.isNotEquals(this._errors,val);

if ( !isValChanged ) {
 return ; 
 }

if ( !this.d3eChanges.contains(LeadImportFile._ERRORS) ) {
 let _old :Array<string>=Array.from(this._errors);

this.updateD3EChanges(LeadImportFile._ERRORS,_old);
 }

this._errors.clear();

this._errors.addAll(val);

this.fire('errors',this);
 }
  public addToErrors ( val : string,index : number = -1 ) : void {
 let _old :Array<string>=[ ];

let _isNewChange :boolean=!this.d3eChanges.contains(LeadImportFile._ERRORS);

if ( _isNewChange ) {
 _old=Array.from(this._errors);
 }

if ( index === -1 ) {
 if ( !this._errors.contains(val) ) this._errors.add(val);
 }
 else {
 this._errors.remove(this._errors.elementAt(index));

this._errors.add(val);
 }

this.fire('errors',this,val,true);

if ( _isNewChange ) {
 this.updateD3EChanges(LeadImportFile._ERRORS,_old);
 }
 }
  public removeFromErrors ( val : string ) : void {
 let _old :Array<string>=[ ];

let _isNewChange :boolean=!this.d3eChanges.contains(LeadImportFile._ERRORS);

if ( _isNewChange ) {
 _old=Array.from(this._errors);
 }

this._errors.remove(val);

this.fire('errors',this,val,false);

if ( _isNewChange ) {
 this.updateD3EChanges(LeadImportFile._ERRORS,_old);
 }
 }
  public get successCount (  ) : number {
 return this._successCount ; 
 }
  public setSuccessCount ( val : number ) : void {
 let isValChanged :boolean=this._successCount !== val;

if ( !isValChanged ) {
 return ; 
 }

this.updateD3EChanges(LeadImportFile._SUCCESSCOUNT,this._successCount);

this._successCount=val;

this.fire('successCount',this);
 }
  public get failCount (  ) : number {
 return this._failCount ; 
 }
  public setFailCount ( val : number ) : void {
 let isValChanged :boolean=this._failCount !== val;

if ( !isValChanged ) {
 return ; 
 }

this.updateD3EChanges(LeadImportFile._FAILCOUNT,this._failCount);

this._failCount=val;

this.fire('failCount',this);
 }
  public get ( field : number ) : any {
 switch ( field ) {
 case LeadImportFile._FILE : {
 return this._file ; 
 }

case LeadImportFile._SUCCESS : {
 return this._success ; 
 }

case LeadImportFile._ERRORS : {
 return this._errors ; 
 }

case LeadImportFile._SUCCESSCOUNT : {
 return this._successCount ; 
 }

case LeadImportFile._FAILCOUNT : {
 return this._failCount ; 
 }
 default: {
 return null ; 
 }
 }
 }
  public updateD3EChanges ( index : number,value : any ) : void {
 if ( this.lockedChanges() ) {
 return ; 
 }

super.updateD3EChanges(index,value);
 }
  public restore (  ) : void {
 /*
TODO: Might be removed
*/

this.d3eChanges.restore(this);
 }
  public deepClone ( clearId = true ) : LeadImportFile {
 let ctx :CloneContext=new CloneContext({ 'clearId':clearId });

return ctx.startClone(this) ; 
 }
  public collectChildValues ( ctx : CloneContext ) : void {
  }
  public deepCloneIntoObj ( dbObj : DBObject,ctx : CloneContext ) : void {
 let obj :LeadImportFile=( dbObj as LeadImportFile );

obj.id=this.id;

obj.setFile(this._file);

obj.setSuccess(this._success);

obj.setErrors(this._errors);

obj.setSuccessCount(this._successCount);

obj.setFailCount(this._failCount);
 }
  public set ( field : number,value : any ) : void {
 switch ( field ) {
 case LeadImportFile._FILE : {
 this.setFile(( value as DFile ));
 break; }

case LeadImportFile._SUCCESS : {
 this.setSuccess(( value as boolean ));
 break; }

case LeadImportFile._ERRORS : {
 this.setErrors(( value as Array<any> ).cast<string>().toList());
 break; }

case LeadImportFile._SUCCESSCOUNT : {
 this.setSuccessCount(( value as number ));
 break; }

case LeadImportFile._FAILCOUNT : {
 this.setFailCount(( value as number ));
 break; }
 }
 }
 }